import { Box, Typography } from "@mui/material"
import { ErrorOutline } from "@mui/icons-material"

import "./style.scss"

interface ErrorProps {
  error: string | null
}

function capitalizeError(error: string): string {
  return error.charAt(0).toUpperCase() + error.slice(1)
}

export default function Error({ error }: ErrorProps) {
  if (!error) {
    return null
  }

  return (
    <Box className="components_optimize-error">
      <Box className="error-content">
        <ErrorOutline className="error-icon" />
        <Typography className="error-message">
          {capitalizeError(error)}
        </Typography>
      </Box>
    </Box>
  )
}
